import { createLogic } from 'redux-logic'
import {
  START_FIRMWARE_UPDATE,
  CANCEL_FIRMWARE_UPDATE,
} from '../constants/firmware'
import { FIRMWARE_TIMEOUT } from '../constants/timeouts'

const startFirmwareUpdateLogic = createLogic({
  type: START_FIRMWARE_UPDATE,
  cancelType: CANCEL_FIRMWARE_UPDATE,
  warnTimeout: FIRMWARE_TIMEOUT,

  transform({ getState, action }, next) {
    const { firmware: { firmwareForUpdate } } = getState()
    next({
      ...action,
      firmwareForUpdate,
    })
  },

  process({ action }, dispatch, done) {
    global.firmwareChannel.perform('firmware_update_start', { firmware: action.firmwareForUpdate })
    done()
  },
})

export default startFirmwareUpdateLogic
